#import "~/graphql/fragments/socialFragment.graphql"

fragment toegewezenbijdragenPageContent on toegewezenBijdragenOverview_Entry {
    title
    description: richTextMinimal
    seo {
        ... socialFragment
    }
    showNewsletterSubscribe
}
